import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { RicercaSoggettoDTO } from "@app/shared/dto/anagrafe/ricerca-soggettoDTO";
import { FiltroSoggettoAnagrafeVO } from "@app/shared/vo/gescor/filtro-soggetto-anagrafeVO";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { AmministrazioneDTO } from "@app/shared/dto/anagrafe/amministrazioneDTO";
import { AooDTO } from "@app/shared/dto/anagrafe/aooDTO";
import { AssociazioneDTO } from "@app/shared/dto/anagrafe/associazioneDTO";
import { CittadinoDTO } from "@app/shared/dto/anagrafe/cittadinoDTO";
import { ImpresaDTO } from "@app/shared/dto/anagrafe/impresaDTO";
import { SoggettoStranieroDTO } from "@app/shared/dto/anagrafe/soggetto-stranieroDTO";
import { UfficioDTO } from "@app/shared/dto/protocollo/ufficioDTO";
import { AmministrazioneNonIpaDTO } from "@app/shared/dto/anagrafe/amministrazione-non-ipaDTO";

@Injectable({
  providedIn: "root"
})
export class MapperRicercaSoggetto
  implements MapperInterface<RicercaSoggettoDTO, FiltroSoggettoAnagrafeVO> {
  convertVoToDto(e: FiltroSoggettoAnagrafeVO): RicercaSoggettoDTO {
    const ricercaSoggettoDTO = new RicercaSoggettoDTO();

    if (
      e.tipoSoggetto === TipoSoggettoAnagrafeEnum.AMMINISTRAZIONE.toString()
    ) {
      ricercaSoggettoDTO.amministrazione = new AmministrazioneDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.amministrazione.codice = e.codice;
      }
      if (e.nome != null) {
        ricercaSoggettoDTO.amministrazione.nomeEsteso = e.nome;
      }
    } else if (e.tipoSoggetto === TipoSoggettoAnagrafeEnum.AOO.toString()) {
      ricercaSoggettoDTO.aoo = new AooDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.aoo.codice = e.codice;
      }
      if (e.nome != null) {
        ricercaSoggettoDTO.aoo.descrizione = e.nome;
      }
    } else if (
      e.tipoSoggetto === TipoSoggettoAnagrafeEnum.ASSOCIAZIONE.toString()
    ) {
      ricercaSoggettoDTO.associazione = new AssociazioneDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.associazione.cf = e.codice;
      }
      if (e.denominazione != null) {
        ricercaSoggettoDTO.associazione.denominazione = e.denominazione;
      }
    } else if (
      e.tipoSoggetto === TipoSoggettoAnagrafeEnum.CITTADINO.toString()
    ) {
      ricercaSoggettoDTO.cittadino = new CittadinoDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.cittadino.cf = e.codice;
      }
      if (e.nome != null) {
        ricercaSoggettoDTO.cittadino.nome = e.nome;
      }
      if (e.cognome != null) {
        ricercaSoggettoDTO.cittadino.cognome = e.cognome;
      }
    } else if (e.tipoSoggetto === TipoSoggettoAnagrafeEnum.IMPRESA.toString()) {
      ricercaSoggettoDTO.impresa = new ImpresaDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.impresa.pi = e.codice;
      }
      if (e.denominazione != null) {
        ricercaSoggettoDTO.impresa.denominazione = e.denominazione;
      }
      if (e.cfImpresa != null) {
        ricercaSoggettoDTO.impresa.cf = e.cfImpresa;
      }
    } else if (
      e.tipoSoggetto === TipoSoggettoAnagrafeEnum.SOGGETTO_STRANIERO.toString()
    ) {
      ricercaSoggettoDTO.soggettoStraniero = new SoggettoStranieroDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.soggettoStraniero.codice = e.codice;
      }
      if (e.denominazione != null) {
        ricercaSoggettoDTO.soggettoStraniero.denominazione = e.denominazione;
      }
      if (e.nazione != null) {
        ricercaSoggettoDTO.soggettoStraniero.nazione = e.nazione;
      }
    } else if (e.tipoSoggetto === TipoSoggettoAnagrafeEnum.UFFICIO.toString()) {
      ricercaSoggettoDTO.ufficio = new UfficioDTO();
      if (e.codice != null) {
        ricercaSoggettoDTO.ufficio.codice = e.codice;
      }
      if (e.denominazione != null) {
        ricercaSoggettoDTO.ufficio.nome = e.denominazione;
      }
    } else if (
      e.tipoSoggetto ===
      TipoSoggettoAnagrafeEnum.AMMINISTRAZIONE_NON_IPA.toString()
    ) {
      ricercaSoggettoDTO.amministrazioneNonIpa = new AmministrazioneNonIpaDTO();
      if (e.nome != null) {
        ricercaSoggettoDTO.amministrazioneNonIpa.nomeEsteso = e.nome;
      }
      if (e.codice != null) {
        ricercaSoggettoDTO.amministrazioneNonIpa.cfPi = e.codice;
      }
    }

    return ricercaSoggettoDTO || new RicercaSoggettoDTO();
  }
  convertDtoToVo(t: RicercaSoggettoDTO): FiltroSoggettoAnagrafeVO {
    throw new Error("Method not implemented.");
  }
  convertListVoToDto(e: FiltroSoggettoAnagrafeVO[]): RicercaSoggettoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: RicercaSoggettoDTO[]): FiltroSoggettoAnagrafeVO[] {
    throw new Error("Method not implemented.");
  }
}
